import { useRouteError } from "react-router-dom";
import {ReactComponent as RocketDestroy} from 'assets/svgs/rocket_destroy.svg';
import { useEffect } from "react";
import { logErrorToMyService } from "helper";


//TODO: Make a proper error page
export default function ErrorPage() {
  const error: any = useRouteError();

  useEffect(() => {
    if(error) {
      logErrorToMyService(error, error.stack)
    }
  }, [error])
  return (
    <div className="h-screen flex flex-col pt-[140px] items-center">
      <RocketDestroy/>
      <h1 className="text-primary-title font-acorn font-bold text-[38px] 2xl:text-[40px] text-center">{error.status === 404 ? 'Page not Found' : 'An Error Occurred'}</h1>
      <p className="text-center text-[16px] 2xl:text-[18px] text-gray-subTextHint font-medium">
        You are about to initiate a page for dev testing.<br/>Select a simulation below:
        {/* <i>{error?.statusText || error.message}</i> */}
        {process.env.NODE_ENV === 'development' ? error?.message : ''}<br/>
        {process.env.NODE_ENV === 'development' ? error?.stack : ''}
      </p>
    </div>
  );
}